import React from 'react'
import { observer } from 'mobx-react'
import ScopeChangeRequestsViewModel from 'admin/scope-change-requests/ScopeChangeRequestsViewModel'
import { ScrollOffsetInterpolation } from 'hooks/spring-hooks'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
} from 'components/StickyViewHeader'
import WorkspaceFilterViewHeading from 'components/WorkspaceFilterViewHeading'

interface ScopeChangeRequestsHeaderProps {
  scrollOffset: ScrollOffsetInterpolation
  vm: ScopeChangeRequestsViewModel
}

export default observer(function ScopeChangeRequestHeader({
  vm,
  scrollOffset,
}: ScopeChangeRequestsHeaderProps) {
  return (
    <StickyViewHeader scrollOffset={scrollOffset}>
      <StickyViewHeaderMain>
        <WorkspaceFilterViewHeading
          allOptionText="All Workspaces"
          primaryText="Change requests"
          filter={vm.searcher.workspaceFilter}
        />
      </StickyViewHeaderMain>
    </StickyViewHeader>
  )
})
